
import moment from 'moment';

const initialState = {
  isLoading: false,
  recaptchaResponse: "",
  limanlar: [],
  limanId: -1,
  willGetAll: false,
  baslangicTarihi: moment().add(-1, 'days'), /* Başlangıç tarihi olarak, bir önceki gün ayarlanıyor initial state'te */
  bitisTarihi: moment(),
  ticaretTipi: 0,
  gemiAdı: "",
  guncelKur: [],
  seferler: [],
  seferFrwList: []
}

export default initialState;


// WEBPACK FOOTER //
// ./src/reducers/initialState.js